<template>
  <div class="inter-refund-rebate-reasons-dialog">
    <el-dialog
      title="退还返利"
      :visible.sync="dialogVisible"
      width="30%"
      @close="resetForm"
    >
      <el-form ref="dataForm" :model="formData" :rules="formRules">
        <el-form-item label="提前退还返利" prop="content">
          <el-input
            v-model="formData.content"
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 6 }"
            placeholder="请输入退还返利原因"
            maxlength="500"
            show-word-limit
            @input="validateInput"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false"> 取 消</el-button>
        <el-button type="primary" @click="submitForm('dataForm')">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getRefundRebateAmount } from '@/API/international';
export default {
  data () {
    return {
      dialogVisible: false,
      formData: {
        content: ''
      },
      formRules: {
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }]
      }
    };
  },
  methods: {
    validateInput (value) {
      // 只允许中英文和数字
      const regex = /^[\u4e00-\u9fa5a-zA-Z0-9]*$/;
      if (!regex.test(value)) {
        // 如果有非法字符，清空输入
        this.formData.content = value.replace(/[^[\u4e00-\u9fa5a-zA-Z0-9]/g, '');
        this.$message.error('只允许输入中英文和数字');
      }
    },
    resetForm () {
      this.$refs.dataForm.resetFields();
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.handleApiCall();
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },
    handleApiCall () {
      getRefundRebateAmount(this.$route.query.contractId).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$message({
            message: json.data,
            type: 'success'
          });
          this.dialogVisible = false;
          // 通知父组件刷新数据
          this.$emit('refreshData');
        }
      });
    },
    showDialog () {
      this.dialogVisible = true;
    }
  }
};
</script>
<style lang="scss">
.inter-refund-rebate-reasons-dialog{
  .el-textarea__inner{
    resize: none;
    font-size: 14px;
    &::placeholder {
      color: #a6a6a6;
      text-align: left;
    }
  }
}
</style>
